export default __webpack_public_path__ + "images/footer-bg-logo.webp";